import { useCallback, useContext, useEffect } from 'react';
import { InspectorContext, ToolbarContext } from './BlockEditor.js';
import { BlockContext } from './BlockViewer.js';
import { outOfScope } from './BlockEditor.js';
/**
 *
 * @returns {{isEditing: boolean, updateData: function}}
 */
export function useEditor() {
    const context = useContext(BlockContext);
    return {
        isEditing: context?.gutenbergBlockProps !== undefined,
        updateData: context?.attributes?.__gutenbergEditor?.setAttributes ?? outOfScope,
    };
}
export function useInspectorControl(rendering, deps = []) {
    const context = useContext(InspectorContext);
    const dispatch = context?.dispatch;
    useEffect(() => {
        if (!dispatch)
            return;
        dispatch({ type: "REGISTER", component: rendering });
        return () => dispatch({ type: "UNREGISTER", component: rendering });
    }, [dispatch, ...deps]);
}
export function useToolbar(rendering, deps = []) {
    const context = useContext(ToolbarContext);
    const dispatch = context?.dispatch;
    useEffect(() => {
        if (!dispatch)
            return;
        dispatch({ type: "REGISTER", component: rendering });
        return () => context.dispatch({ type: "UNREGISTER", component: rendering });
    }, [dispatch, ...deps]);
}
export function useSmartProp(name) {
    const blockContext = useContext(BlockContext);
    const { updateData } = useEditor();
    const setter = useCallback(newValue => {
        return updateData({ [name]: newValue });
    }, [updateData, name]);
    return [
        blockContext?.attributes[name],
        setter
    ];
}

//# sourceMappingURL=blockEditorHooks.js.map
